module.exports = __webpack_public_path__ + "img/plan_2.d5e9c006.webp";